"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _commonConstants = require("../../../../utils/common-constants");

var _constants = require("./constants");

var _Member = _interopRequireDefault(require("./Member"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.members-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .members-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .members-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n  .members-header-class .header-class .margin-top-10 {\n    margin-top: 0.625rem; }\n\n.members-header-class .approval-loader-container {\n  display: flex;\n  justify-content: center; }\n\n.members-header-class .members-tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 0.625rem;\n  max-height: 7.5rem;\n  overflow-y: auto;\n  min-height: 1.25rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .members-header-class .members-tag-container .view-member-pills-container {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n    margin-right: 1rem; }\n";
  var fileName = "compone_Members";
  var element = document.querySelector("style[data-sass-component='compone_Members']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function PolicyViewMembers(_ref) {
  var memberData = _ref.memberData,
      memberLabels = _ref.memberLabels,
      translatedStrings = _ref.translatedStrings,
      viewPolicyHeaders = _ref.viewPolicyHeaders,
      consumer = _ref.consumer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, " ", viewPolicyHeaders === null || viewPolicyHeaders === void 0 ? void 0 : viewPolicyHeaders.members, " ")), /*#__PURE__*/_react.default.createElement(_Member.default, {
    label: memberLabels === null || memberLabels === void 0 ? void 0 : memberLabels.user,
    entities: memberData === null || memberData === void 0 ? void 0 : memberData.users,
    translatedStrings: translatedStrings,
    allEntitiesLabel: translatedStrings.allUsers
  }), /*#__PURE__*/_react.default.createElement(_Member.default, {
    label: memberLabels === null || memberLabels === void 0 ? void 0 : memberLabels.tags,
    entities: memberData === null || memberData === void 0 ? void 0 : memberData.tags,
    translatedStrings: translatedStrings,
    allEntitiesLabel: translatedStrings.allTags
  }), /*#__PURE__*/_react.default.createElement(_Member.default, {
    label: memberLabels === null || memberLabels === void 0 ? void 0 : memberLabels.identities,
    entities: memberData === null || memberData === void 0 ? void 0 : memberData.serviceIdentities,
    translatedStrings: translatedStrings,
    allEntitiesLabel: translatedStrings.allServiceIdentities
  }), consumer !== _commonConstants.papServiceConsumer && /*#__PURE__*/_react.default.createElement(_Member.default, {
    label: memberLabels === null || memberLabels === void 0 ? void 0 : memberLabels.tokens,
    entities: memberData === null || memberData === void 0 ? void 0 : memberData.tokens,
    translatedStrings: translatedStrings,
    allEntitiesLabel: translatedStrings.allTokens
  }));
}

PolicyViewMembers.propTypes = {
  translatedStrings: _propTypes.default.object,
  memberData: _propTypes.default.shape({
    users: _propTypes.default.oneOf([undefined, _propTypes.default.array]),
    tags: _propTypes.default.oneOf([undefined, _propTypes.default.array]),
    channels: _propTypes.default.oneOf([undefined, _propTypes.default.array]),
    serviceIdentities: _propTypes.default.oneOf([undefined, _propTypes.default.array]),
    tokens: _propTypes.default.oneOf([undefined, _propTypes.default.array])
  }),
  memberLabels: _propTypes.default.shape({
    user: _propTypes.default.string,
    tags: _propTypes.default.string,
    identities: _propTypes.default.string,
    tokens: _propTypes.default.string
  }),
  viewPolicyHeaders: _propTypes.default.shape({
    general: _propTypes.default.string,
    members: _propTypes.default.string,
    generic: _propTypes.default.string,
    approvals: _propTypes.default.string
  }),
  consumer: _propTypes.default.string
};
var _default = PolicyViewMembers;
exports.default = _default;